import {
    DRAFT_STATUS_0,
    DRAFT_STATUS_100,
    DRAFT_STATUS_20,
    DRAFT_STATUS_40,
    DRAFT_STATUS_60,
    DRAFT_STATUS_80,
} from "../../../../constants/generalConstants"

export const COMPLETION_STATUS = [
    {
        title: "From 0% to 20%",
        statusFrom: DRAFT_STATUS_0,
        statusTo: DRAFT_STATUS_20,
    },
    {
        title: "From 20% to 40%",
        statusFrom: DRAFT_STATUS_20,
        statusTo: DRAFT_STATUS_40,
    },
    {
        title: "From 40% to 60%",
        statusFrom: DRAFT_STATUS_40,
        statusTo: DRAFT_STATUS_60,
    },
    {
        title: "From 60% to 80%",
        statusFrom: DRAFT_STATUS_60,
        statusTo: DRAFT_STATUS_80,
    },
    {
        title: "From 80% to 100%",
        statusFrom: DRAFT_STATUS_80,
        statusTo: DRAFT_STATUS_100,
    },
]
